<template>
  <div
    class="support-row"
    :class="{ 'support-row--unread': !notification.isRead }"
    role="button"
    tabindex="0"
    @click="$emit('open', notification)"
    @keydown.enter="$emit('open', notification)"
  >
    <div class="support-row__icon" :class="`support-row__icon--${kind.tone}`">
      <v-icon size="18">
        {{ kind.icon }}
      </v-icon>
    </div>

    <div class="support-row__body">
      <div class="support-row__head">
        <span class="support-row__title">{{ title }}</span>
        <span class="support-row__time">{{ time }}</span>
      </div>
      <div class="support-row__text">
        {{ text }}
      </div>
    </div>

    <!-- Зона 80 справа только у непрочитанной строки; клик по ней не открывает тикет (stop) -->
    <button
      v-if="action === 'read'"
      type="button"
      class="support-row__action"
      @click.stop="$emit('read', notification)"
    >
      <v-icon size="22">
        mdi-check
      </v-icon>
      Прочитано
    </button>
    <!-- «Оценить» ведёт в тикет к карточке оценки; прочитанным «Решено» становится там же -->
    <button
      v-else-if="action === 'rate'"
      type="button"
      class="support-row__action support-row__action--rate"
      @click.stop="$emit('open', notification)"
    >
      <v-icon size="22">
        mdi-star-outline
      </v-icon>
      Оценить
    </button>
  </div>
</template>

<script>
  import {
    notificationTime,
    supportAction,
    supportKind,
    supportText,
    supportTitle,
  } from './notifications'

  /** Строка уведомления FAKT Support в колокольчике CRM (p7): иконка подтипа, текст, зона действия. */
  export default {
    name: 'NotificationSupportRow',
    props: {
      notification: { type: Object, required: true },
    },
    computed: {
      kind () {
        return supportKind(this.notification.type)
      },
      title () {
        return supportTitle(this.notification)
      },
      text () {
        return supportText(this.notification)
      },
      time () {
        return notificationTime(this.notification.createdAt)
      },
      action () {
        return supportAction(this.notification)
      },
    },
  }
</script>

<style lang="less" scoped>
@import './tokens.less';

.support-row {
  display: flex;
  align-items: stretch;
  min-height: 80px;
  overflow: hidden;
  border: 1px solid @fakt-divider;
  border-radius: 8px;
  background: @fakt-white;
  cursor: pointer;
  transition: background-color 0.45s ease;

  &:hover {
    background: @fakt-surface;
  }

  &--unread {
    border-color: @fakt-cream-border;
    background: @fakt-cream-soft;

    &:hover {
      background: @fakt-cream-plate;
    }
  }
}

.support-row__icon {
  display: flex;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  align-self: center;
  height: 36px;
  margin: 0 16px;
  border-radius: 50%;
  background: @fakt-cream-plate;

  &--orange .v-icon {
    color: @fakt-orange;
  }

  &--green .v-icon {
    color: @fakt-green;
  }

  &--grey {
    background: @fakt-surface;

    .v-icon {
      color: @fakt-text-2;
    }
  }
}

.support-row__body {
  flex: 1;
  min-width: 0;
  padding: 12px 16px 12px 0;
}

.support-row__head {
  display: flex;
  gap: 12px;
  align-items: baseline;
  justify-content: space-between;
}

.support-row__title {
  font-size: 14px;
  font-weight: 500;
  color: @fakt-text;
}

.support-row__time {
  flex-shrink: 0;
  font-size: 12px;
  color: @fakt-text-2;
}

// Вторая строка - до двух строк, дальше многоточие (11-acceptance.md).
.support-row__text {
  display: -webkit-box;
  margin-top: 4px;
  overflow: hidden;
  font-size: 12px;
  line-height: 17px;
  color: @fakt-text-2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.support-row__action {
  display: flex;
  flex: 0 0 80px;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
  color: @fakt-text;
  background: @fakt-cream-plate;
  transition: background-color 0.2s ease, transform 0.1s ease;

  .v-icon {
    color: @fakt-orange;
  }

  // Под курсором - оранжевая с белой иконкой, как «Прочитано» в деске
  &:hover {
    color: @fakt-white;
    background: @fakt-orange;

    .v-icon {
      color: @fakt-white;
    }
  }

  &:active {
    transform: scale(0.94);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:active {
      transform: none;
    }
  }
}
</style>
